import { Vue, Inject, Prop, Component, Watch } from "vue-property-decorator";
import { Http } from "@status/codes";
import { EventService } from "../../services/EventService";
import Snackbar from "../../../../shared/components/Snackbar/Snackbar";
import { Event, EventDataDTO } from "../../models/event.model";
import { EventQuery } from "../../models/EventQuery";
import EmptyState from "@/shared/components/EmptyState/EmptyState.vue";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import {
  EMITTED_EVENT,
  EVENT,
  EVENTS_ACCESS,
  EVENT_MESSAGES,
  FILTERS_LIST,
  ICONS_COLORS,
  ICONS_TYPES,
  LABEL,
  MAIN_FILTER,
  MINUTE_IN_MS
} from "../../constants/EventConstants";
import ScrollBottom from "@/shared/components/ScrollBottom/ScrollBottom.vue";
import ModalDetails from "../ModalDetails/ModalDetails.vue";
import {
  NAME_FINDERS,
  OPTIONS_LOCALE_DATE,
  SOCKET_TOPICS
} from "@/shared/constants/GeneralConstants";
import DocumentViewer from "@/shared/components/DocumentViewer/DocumentViewer.vue";
import EventCard from "../EventCard/EventCard.vue";
import { DocumentService } from "@/modules/Document/services/DocumentService";
//import { IMG_TYPE_EXTENSIONS } from "@/shared/constants/FileConstants";
import {
  DOCUMENTS_ACCESS,
  DOWNLOAD_ONLY_FLAG
  /* GOOGLE_DRIVE_URL*/
} from "@/modules/Document/constants/DocumentConstants";
import { AxiosError } from "axios";
import { FORM_MESSAGES } from "@/shared/constants/FormConstants";
import GenericSearchBar from "@/shared/components/GenericSearchBar/GenericSearchBar.vue";
import { AES, enc } from "crypto-js";
import { GO_TO_TOP, TIMELINE_ID } from "@/modules/Home/constants/HomeConstants";

@Component({
  name: "ListEvents",
  components: {
    ScrollBottom,
    EmptyState,
    GenericSearchBar,
    ModalDetails,
    DocumentViewer,
    EventCard
  }
})
export default class ListEvents extends Vue {
  @Prop() private userId!: string;

  @Inject() eventService!: EventService;
  @Inject() documentService!: DocumentService;

  basicBtnClassRound = STYLE_CLASSES.BASIC_ROUND_BTN;
  EMPTY_STATE_HEADER = EVENT.EMPTY_STATE.HEADER;
  EMPTY_STATE_PARAGRAPH = EVENT.EMPTY_STATE.PARAGRAPH;

  eventData: EventDataDTO = {
    userId: this.userId,
    type: "",
    notes: []
  };
  eventDataList: Array<Event> = [];
  eventQuery: EventQuery = { userId: "" };
  loadingData = false;
  showCardsContainer = false;
  docref = "";
  canSearch = true;
  ICON_TYPES = ICONS_TYPES;
  ICON_COLORS = ICONS_COLORS;
  SWITCH_NAME = LABEL.SWITCH;
  CHANNEL = LABEL.CHANNEL;
  DOCUMENT = MAIN_FILTER.DOCUMENT;
  filterArraySearch = FILTERS_LIST;
  SEARCH_LIST_EVENT_KEY = NAME_FINDERS.LIST_EVENT;

  options = OPTIONS_LOCALE_DATE;

  showModalDetails = false;
  documentDialog = false;
  documentName = "";
  documentURL = "";
  bottomEventList = false;
  showGoTopBtn = false;
  TIMELINE_ID = TIMELINE_ID;
  GO_TO_TOP_BTN = GO_TO_TOP;
  primaryBtnRoundClass = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  documentURLDownload = "";
  @Watch("userId")
  refreshData() {
    this.docref = "";
    this.canSearch = true;
    this.eventDataList = [];
    this.loadPages();
  }

  async mounted() {
    await this.loadPages();
    this.initListener();
  }

  initListener() {
    this.$socket.$subscribe(
      SOCKET_TOPICS.NEW_EVENT,
      this.processSocketsPayload
    );
  }

  processSocketsPayload(payload: string) {
    const payloadBytes = AES.decrypt(
      payload,
      process.env.VUE_APP_TOKEN_SECRET as string
    );
    const eventData = payloadBytes.toString(enc.Utf8);
    const event: Event = JSON.parse(eventData);
    event.isNew = true;
    const result = this.validateNewEvent(event);
    if (result) {
      this.$emit(EMITTED_EVENT.NEW_EVENT);
      const date = event.dateCreated ? new Date(event.dateCreated) : new Date();
      const dateNow = date.getTime();
      this.eventDataList.map((event: Event) => {
        if (event.isNew && event.dateCreated) {
          const eventDate = new Date(event.dateCreated).getTime();
          event.isNew = dateNow - eventDate < MINUTE_IN_MS;
        }
        return event;
      });
      this.eventDataList.unshift(event);
    }
  }

  validateNewEvent(event: Event) {
    const filter: EventQuery = this.eventQuery;
    const user = filter.user || filter.userId;
    if (filter.createdBy && event.createdBy != filter.createdBy) return false;
    else if (!filter.createdBy && event.userId != user) return false;
    if (filter.type && event.type != filter.type) return false;
    if (filter.name && !event.title?.includes(filter.name)) return false;
    if (
      filter.dateStart &&
      event.dateCreated &&
      event.dateCreated < Number(filter.dateStart)
    )
      return false;
    if (
      filter.dateEnd &&
      event.dateCreated &&
      event.dateCreated > Number(filter.dateEnd)
    )
      return false;
    return true;
  }

  searchData(data: EventQuery) {
    data.type = data.mainFilterKey;
    delete data.mainFilterKey;
    delete data.filterDate;
    delete data.allSelectFilter;

    if (data.name) {
      data.name = data.name[0];
    }
    this.searchWithFilter(data);
  }

  async loadPages(filter?: EventQuery) {
    try {
      this.loadingData = true;

      this.eventQuery = { userId: this.userId };
      Object.assign(this.eventQuery, filter);
      if (this.docref !== "") this.eventQuery.docref = this.docref;
      const eventResp = await this.eventService.getEventByFilter(
        this.eventQuery
      );
      if (eventResp.data === undefined) {
        Snackbar.popInfo(EVENT_MESSAGES.RESPONSE_EVENTS_UNDEFINED);
        this.loadingData = false;
        this.bottomEventList = true;
        return;
      }
      if (eventResp.code === Http.Found && eventResp.data !== undefined) {
        if (eventResp.data.docref !== this.docref) {
          this.eventDataList = this.eventDataList.concat(eventResp.data.events);
          this.docref = eventResp.data.docref;
        } else {
          this.canSearch = false;
        }
        this.loadingData = false;
      } else if (eventResp.code === Http.NotFound) {
        Snackbar.popInfo(eventResp.message);
        this.canSearch = false;
        this.loadingData = false;
        return;
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden) {
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + EVENTS_ACCESS.GET);
      } else Snackbar.popError(EVENT_MESSAGES.REQUEST_FAILED);
      this.loadingData = false;
      return;
    }
  }

  async getDocumentURL(id: string): Promise<string> {
    try {
      const documentURLResponse = await this.documentService.getDocumentsURL(
        id
      );
      if (documentURLResponse.code === Http.Found && documentURLResponse.data) {
        return documentURLResponse.data;
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + DOCUMENTS_ACCESS.GET
        );
      else Snackbar.popError(EVENT_MESSAGES.REQUEST_FAILED);
    }
    return "";
  }

  async searchWithFilter(filter: EventQuery) {
    this.eventDataList = [];
    this.docref = "";
    this.canSearch = true;
    this.bottomEventList = false;

    if (filter.type === "all") Reflect.deleteProperty(filter, "type");

    await this.loadPages(filter);
  }

  async onBottom() {
    if (this.canSearch && !this.loadingData && !this.bottomEventList)
      await this.loadPages(this.eventQuery);
  }

  async showNotes(event: Event) {
    this.loadingData = true;
    try {
      Object.assign(this.eventData, event);
      const notesReponse = await this.eventService.getNotesByEventTimeLineId(
        this.eventData.id as string
      );
      if (notesReponse.code === Http.Found && notesReponse.data !== undefined) {
        Vue.set(this.eventData, "notes", notesReponse.data.notes);
        this.showModalDetails = true;
        this.loadingData = false;
      } else {
        Snackbar.popError(notesReponse.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + EVENTS_ACCESS.GET);
      else Snackbar.popError(EVENT_MESSAGES.REQUEST_FAILED);
    }
    this.loadingData = false;
  }

  handleModalClose() {
    this.showModalDetails = false;
  }

  async showPreview(event: Event) {
    if (event.refId) {
      this.documentName = event.title ?? "";
      const fileType = this.documentName.split(".").pop() ?? "";
      const documentPath = await this.getDocumentURL(event.refId);
      this.getURL(fileType, documentPath);
    }

    if (this.documentURL.includes(DOWNLOAD_ONLY_FLAG)) {
      this.documentURL = this.documentURL.replace(DOWNLOAD_ONLY_FLAG, "");
      this.documentURLDownload = this.documentURL;
      return;
    }
    this.documentDialog = true;
  }

  getURL(fileType: string, documentPath: string) {
    this.documentURL = documentPath;
    //TODO - descomentar y eliminar la linea anterior cuando se migren los docs
    // if (IMG_TYPE_EXTENSIONS.includes(fileType)) {
    //   this.documentURL = documentPath;
    // } else {
    //   const encodedURI = encodeURIComponent(documentPath);
    //   this.documentURL = `${GOOGLE_DRIVE_URL}${encodedURI}`;
    // }
  }

  closePreview() {
    this.documentURL = "";
    this.documentDialog = false;
  }
  onScroll(event: any) {
    const target = event.target as HTMLElement;
    if (target.scrollTop + target.clientHeight + 5 >= target.scrollHeight) {
      this.onBottom();
    }
    this.showGoTopBtn = target.scrollTop >= 100;
  }

  goToTop() {
    const target = document.getElementById(this.TIMELINE_ID);
    if (target) {
      target.scrollTop = 0;
      this.showGoTopBtn = false;
    }
  }
}
